import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import Oops from '../../components/ErrorPages/Oops';
import QuoteButton from '../../components/QuoteButton/QuoteButton';
import withStoryblok from "../../components/withStoryblok";
import { ENTRIES } from "../../store/content-store";


function NotFound({ contentStore }){
  const content = contentStore.getBlocks(ENTRIES.home);
  const quote_buttons = content('get_quotes', []);

  return (
    <Container className="py-3 py-md-5 flex-grow-1 my-auto d-table">
      <Row>
        <Col xs={12} md={7} className="m-auto">
          <Oops message="We can't find exactly what you requested, but perhaps one of these may be of interest." />
        </Col>
      </Row>
      <Row className="my-3 my-md-5 text-left">
        {quote_buttons.map(i => <QuoteButton key={i._uid} {...i} />)}
      </Row>
      <Row>
        <Col xs={12} md={3} className="m-auto">
          <Link to="/" className="btn btn-primary btn-block">Return to Home</Link>
        </Col>
      </Row>
    </Container>
  )
}

export default withStoryblok(NotFound, ENTRIES.home);
